import STSRepeatedAttemptTestBase from './STSRepeatedAttemptTestBase';
import type { StsRepetitionResultPayload } from '../sts/stsDomain';

interface STS1MinTestProps {
  initial?: StsRepetitionResultPayload | null;
  patientContext?: {
    birthDate?: string | null;
    ageYears?: number | null;
    sex?: string | null;
    weightKg?: number | null;
    heightCm?: number | null;
    identifier?: string | null;
  };
  onCancel?: () => void;
  onDraftAttempt?: (payload: StsRepetitionResultPayload) => Promise<boolean | void> | boolean | void;
  onNext: (result: StsRepetitionResultPayload) => void;
}

export type { StsRepetitionResultPayload as STS1MinResultPayload };

export default function STS1MinTest(props: STS1MinTestProps) {
  return (
    <STSRepeatedAttemptTestBase
      {...props}
      testKey="STS_1MIN"
      title="Sentar-Levantar de 1 min (1 min STS)"
      description="Durante 1 minuto, o paciente deve levantar e sentar o maior número de vezes possível, podendo descansar se necessário. Em geral realiza-se 1 tentativa, mas a V2 permite salvar a 1ª e registrar uma 2ª com o intervalo real."
      durationSeconds={60}
      recommendedRestSeconds={900}
      allowFinalizeAfterFirstAttempt
      saveLabel="Salvar 1 min STS"
    />
  );
}
